/**
 * Admin Shell Navigation
 * Sidebar with links to all resource pages
 */

import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Divider,
  Typography,
} from '@mui/material';
import { useLocation, Link as RouterLink } from 'react-router-dom';

const navItems = [
  { label: 'Dashboard', path: '/' },
  { label: 'Businesses', path: '/businesses' },
  { label: 'Users', path: '/users' },
  { label: 'Services', path: '/services' },
  { label: 'Providers', path: '/providers' },
  { label: 'Analytics', path: '/analytics' },
  { label: 'User Outreach', path: '/user-outreach' },
];

export function AdminShellNavigation() {
  const location = useLocation();

  return (
    <Box sx={{ width: 250, p: 2 }}>
      <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, color: '#7FA897' }}>
        Tilly Admin
      </Typography>
      <Divider sx={{ mb: 2 }} />
      <List>
        {navItems.map((item) => (
          <ListItem key={item.path} disablePadding>
            <ListItemButton
              component={RouterLink}
              to={item.path}
              selected={location.pathname === item.path}
              sx={{
                borderRadius: 1,
                mb: 1,
                '&.Mui-selected': {
                  backgroundColor: '#E6F0EB',
                  color: '#7FA897',
                  '& .MuiListItemText-primary': {
                    fontWeight: 600,
                  },
                },
              }}
            >
              <ListItemText primary={item.label} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );
}
